import "./Banner.css";

interface BannerProps {
  displayedBanner?: string | null;
  firstName?: string | undefined;
  fundName?: string | undefined;
  corners?: "default" | "rounded";
}

export const Banner = ({ displayedBanner, firstName, fundName, corners }: BannerProps): JSX.Element => {
  const normalizedBannerUrl = displayedBanner?.trim() || undefined;
  const backgroundImage = normalizedBannerUrl ? `url("${normalizedBannerUrl.replaceAll('"', "%22")}")` : undefined;

  return (
    <div className="BannerContainerLabel">
      <div
        aria-labelledby="Banner"
        className={`BannerContainer ${corners} ${backgroundImage == null ? "DefaultBackground" : ""}`}
        style={{ backgroundImage }}
      >
        <div className="TextContainer">
          {firstName && <h1>Welcome, {firstName}</h1>}
          {fundName && <p className="body2">{fundName}</p>}
        </div>
      </div>
    </div>
  );
};
